import React, { Component } from "react";
import { Text, View, Animated, StyleSheet } from "react-native";

export default class SlideUp extends Component {
  state = {
    animatedValue: new Animated.Value(0),
    duration: this.props.duration || 500
  };
  static defaultProps = {
    duration: 300,
    delayValue: 300,
    animationDirection: 'up'
  };

  componentDidMount() {
    let { startWhen } = this.props;
    if (!this.props.hasOwnProperty("startWhen")) {
      this._start();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    let { startWhen } = this.props;
    if (startWhen !== prevProps.startWhen) {
      this._start();
    }
  }

  _start = () => {
    Animated.timing(this.state.animatedValue, {
      toValue: 1,
      duration: this.state.duration,
      useNativeDriver: true
    }).start();
  };
  render() {
    let { animatedValue } = this.state;
    let { children, delayValue=300, style, animationDirection, ...props } = this.props;
    const _animationDirection = animationDirection === 'up' ? 'translateY' : animationDirection === 'left' ? 'translateX' : 'translateY';
    return (
      <Animated.View
        {...props}
        style={{
          ...style,
          transform: [
            {
              [_animationDirection]: animatedValue.interpolate({
                inputRange: [0, 1],
                outputRange: [2000, 0]
              })
            },
            {
              perspective: 1000
            }
          ]
        }}
      >
        {children}
      </Animated.View>
    );
  }
}